import Settings from './Settings';
import Security from './Security';


export {
    Settings,
    Security,
}